<template>
  <div :class="[getExtraClass]" :key="selectKey">
    <md-field class="material-select" id="material-select-field">
      <label :for="selectFor" v-if="label">{{ label }}</label>
      <md-select
        v-model="content"
        :name="selectFor"
        :id="selectFor"
        :placeholder="selectLabel"
        @md-opened="selectOpen"
        @md-selected="setOption"
        :multiple="multiple"
        :mdClass="getDropDownClass"
        ref="select-options-box"
        @click.self="selectClick"
      >
        <div
          v-for="(option, index) in options"
          :key="index"
          data-cy="select-content"
        >
          <md-option
            :data-cy="`${option.dataCy}-select`"
            :value="option.value"
            >{{ option.label }}</md-option
          >
        </div>
      </md-select>
    </md-field>
  </div>
</template>

<script>
export default {
  name: "SSelectMaterial",
  props: [
    "options",
    "selectLabel",
    "selectFor",
    "extraClass",
    "input",
    "multiple",
    "label",
    "dropDownClass",
  ],
  model: {
    prop: "input",
    event: "md-selected",
  },
  data() {
    return {
      content: this.input,
      selectKey: 0,
      isScrolling: false,
      dropdownSize: "",
      state: false,
    };
  },
  computed: {
    getExtraClass() {
      if (this.extraClass) {
        return "itemConditionDrop"
      }
      return "";
    },
    getDropDownClass() {
      switch (this.dropDownClass) {
        case "category":
          return "dropdown-category";
        case "condition":
          return "dropdown-condition";
        case "trade":
          return "dropdown-trade";
        case "searchType":
          return "dropdown-search-type";
        case "searchItemCategory":
          return "dropdown-search-category";
        case "searchItemCondition":
          return "dropdown-search-condition";
        case "searchItemSort":
          return "dropdown-search-sort";
        case "searchItemTrade":
          return "dropdown-search-trade";
        case "searchGroupPrivacy":
          return "dropdown-search-privacy";
        case "searchGroupPrivacyBoth":
          return "dropdown-search-privacy-both";
        default:
          return "";
      }
    },
  },
  methods: {
    setOption() {
      this.$emit("md-selected", this.content);
    },
    update() {
      this.selectKey++;
    },
    selectClick() {
      this.state=!this.state
      this.$refs['select-options-box'].showSelect=this.state
    },
    selectOpen() {
      this.$nextTick(function () {
        this.$nextTick(function () {
          this.$nextTick(function () {
            if (this.$route.name === 'landingPage') {
              $(".md-select-menu").css(
              "top",
              $("#material-select-field").offset().top + 46,
            );
            }else {
              $(".md-select-menu").css(
                "top",
                $("#material-select-field").offset().top + 39,
              );
            }
          });
        });
      });
    },
    handleScroll() {
      window.clearInterval(this.isScrolling);
      this.isScrolling = setTimeout(() => {
        this.isScrolling = false;
      });
    },
  },
  watch: {
    input(val) {
      this.content = val;
      this.setOption();
    },
    isScrolling(val) {
      if (val === false) {
        this.selectOpen();
      }
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
.md-menu.md-select {
  align-items: center;
}

.material-select {
  padding-top: 0;
  margin: 0 0 24px 0;
}
.material-select .md-menu {
  background-color: $white !important;
  border: 1px solid $dark;
  box-sizing: border-box;
  border-radius: 6px;
}
.md-field:after {
  height: 0;
}
.md-field:before {
  height: 0px;
}
.label {
  font-size: 14px;
  margin-left: 11px;
  top: 15px;
}
</style>

<style lang="scss">
.material-select .md-menu .md-input {
  height: 100%;
}
.material-select .md-menu input {
  padding: 8px !important;
  font-size: 14px !important;
}
.md-selected span {
  color: $primary;
}
.md-select-menu {
  width: 11%;
  border-radius: 7px;
}
.dropdown-condition {
  width: 160px !important;
  margin-left: 15px;
}
.dropdown-category {
  width: 125px !important;
  margin-left: 15px;
}
@media screen  and (max-width: 430px) {
  .dropdown-category {
    margin-left: -8px;
  }
}
@media screen  and (min-width: 431px) and (max-width: 495px) {
  .dropdown-category {
    margin-left: 3px;
  }
}
@media screen  and (min-width: 496px) and (max-width: 540px) {
  .dropdown-category {
    margin-left: 8px;
  }
}
@media screen and (min-width: 541px) and (max-width: 735px) {
  .dropdown-category {
    margin-left: 1.2rem;
  }
}
@media screen and (min-width: 736px) and (max-width: 960px) {
  .dropdown-category {
    margin-left: -0.6rem;
  }
}
.dropdown-search-type {
  width: 170px !important;
  border-radius: 7px;
  margin-left: 15px;
}
.dropdown-search-category {
  width: 170px !important;
  margin-left: 1rem;
}
.dropdown-search-condition {
  width: 180px !important;
  margin-left: 1rem;
}
.dropdown-search-sort {
  width: 180px !important;
  margin-left: 1rem;
}
.dropdown-search-trade {
  width: 170px !important;
  margin-left: 1rem;
}
.dropdown-search-privacy {
  width: 170px !important;
  margin-left: 1rem;
}
.dropdown-search-privacy-both {
  width: 170px !important;
  margin-left: 1rem;
}
@media screen and (min-width: 570px) and (max-width: 1023px) {
  .dropdown-search-trade {
    margin-top: 0.125rem;
  }
  .dropdown-search-privacy-both {
    margin-top: 6rem;
  }
}
@media screen and (min-width: 380px) and (max-width: 570px) {
  .dropdown-search-category {
    margin-top: 5rem;
  }
  .dropdown-search-condition {
    margin-top: 10rem;
  }
  .dropdown-search-trade {
    margin-top: 15rem;
  }
  .dropdown-search-sort {
    margin-top: 20rem;
  }
  .dropdown-search-privacy-both {
    margin-top: 12rem;
  }
}
@media screen and (min-width: 371px) and (max-width: 380px) {
  .dropdown-search-category {
    margin-top: 5rem;
  }
  .dropdown-search-condition {
    margin-top: 10rem;
  }
  .dropdown-search-trade {
    margin-top: 15rem;
  }
  .dropdown-search-sort {
    margin-top: 20rem;
  }
  .dropdown-search-privacy-both {
    margin-top: 24rem;
  }
  .dropdown-search-privacy {
    margin-top: 6rem;
  }
}
@media screen and (max-width: 370px) {
  .dropdown-search-category {
    margin-top: 5rem;
  }
  .dropdown-search-condition {
    margin-top: 10rem;
  }
  .dropdown-search-trade {
    margin-top: 15rem;
  }

  .dropdown-search-sort {
    margin-top: 20rem;
  }
  .dropdown-search-privacy-both {
    margin-top: 24rem;
  }
  .dropdown-search-privacy {
    margin-top: 6rem;
  }

}
.md-menu-content-container {
  border-radius: 7px;
  border: 1px solid $dark;
}
.md-checkbox.md-theme-swampum-primary .md-checkbox-container {
  border: 0.5px solid $primary;
  border-radius: 2px;
}
.md-list-item-content > .md-checkbox:first-child,
.md-list-item-content > .md-radio:first-child {
  margin-right: 5px;
  order: 1;
}
</style>
